import React, { useState } from 'react';
import { FiX, FiSearch } from 'react-icons/fi';

export default function AssignRoleModal({ isOpen, onClose, onAssign, role, users }) {
  const [selectedUserId, setSelectedUserId] = useState('');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const filteredUsers = users.filter(user => 
    !user.role_id || user.role_id !== role?._id
  ).filter(user => 
    user.username.toLowerCase().includes(search.toLowerCase()) ||
    user.email.toLowerCase().includes(search.toLowerCase()) ||
    (user.full_name && user.full_name.toLowerCase().includes(search.toLowerCase()))
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUserId) return;
    
    setLoading(true);
    await onAssign(selectedUserId, role._id);
    setLoading(false);
    onClose();
    setSelectedUserId('');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl w-full max-w-md">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold">
            Assign Role: <span className="text-primary-500">{role?.name}</span>
          </h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-lg">
            <FiX className="w-5 h-5" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select User
            </label>
            <div className="relative mb-3">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by username, email, or name..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-primary-500"
              />
            </div>
            
            <div className="max-h-64 overflow-y-auto border rounded-lg">
              {filteredUsers.length === 0 ? (
                <p className="text-gray-500 text-center py-4">
                  {search ? 'No users found' : 'All users already have roles'}
                </p>
              ) : (
                filteredUsers.map(user => (
                  <label
                    key={user._id}
                    className={`flex items-center p-3 cursor-pointer transition ${
                      selectedUserId === user._id
                        ? 'bg-primary-50 border-primary-500'
                        : 'hover:bg-gray-50'
                    } border-b last:border-0`}
                  >
                    <input
                      type="radio"
                      name="user"
                      value={user._id}
                      checked={selectedUserId === user._id}
                      onChange={(e) => setSelectedUserId(e.target.value)}
                      className="mr-3"
                    />
                    <div>
                      <p className="font-medium text-gray-800">{user.full_name || user.username}</p>
                      <p className="text-xs text-gray-500">{user.email}</p>
                      {user.role_id && (
                        <p className="text-xs text-gray-400">
                          Current role: {user.role_id.name}
                        </p>
                      )}
                    </div>
                  </label>
                ))
              )}
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-lg transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!selectedUserId || loading}
              className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 transition"
            >
              {loading ? 'Assigning...' : 'Assign Role'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
